import { get, post } from '@/utils/request1';

export const addressAdd = (data) => post('index/addaddress',data); // 添加收发件地址
export const address = (data) => post('index/addressList',data); // 收发件地址列表
// export const defaultAddress = (param) => get('users/default_address',param); // 默认的收发件地址
export const defaultUpdate = (data) => post('users/default_update',data); // 修改收发件默认地址
export const addressUpdate = (data) => post('index/editaddress',data); // 修改收发件地址
export const addressDel = (data) => post('index/deladdress',data); // 删除收发件地址